import type { Messages } from "./en";
export const fr: Messages = {
  "meta.title": "ArtLove365 - Peintures à l'huile faites main",
  "meta.description": "Reproductions à l'huile peintes à la main des plus grands chefs-d'œuvre du monde, et portraits à l'huile sur mesure d'après vos photos.",
  "nav.gallery": "Galerie",
  "nav.artists": "Artistes",
  "nav.custom": "Peindre ma photo",
  "nav.track": "Suivre ma commande",
  "home.eyebrow": "Peint à l'huile, à la main, par de vrais artistes",
  "home.title": "Des chefs-d'œuvre pour vos murs. Vos souvenirs, peints comme des chefs-d'œuvre.",
  "home.subtitle": "Choisissez parmi les tableaux les plus aimés de l'histoire, ou envoyez votre propre photo. Nos artistes la peignent à la main sur toile et vous la livrent.",
  "home.ctaGallery": "Voir la galerie",
  "home.ctaCustom": "Envoyer une photo",
  "home.stepsTitle": "Comment ça marche",
  "home.step1Title": "Choisissez ou envoyez",
  "home.step1Body": "Choisissez un chef-d'œuvre, ou envoyez une photo de votre famille, de votre animal ou d'un lieu cher.",
  "home.step2Title": "Nous la peignons",
  "home.step2Body": "Un peintre professionnel travaille sur une vraie toile. Pour le sur-mesure, vous validez d'abord une esquisse.",
  "home.step3Title": "Livré chez vous",
  "home.step3Body": "Après séchage, votre tableau est soigneusement emballé et expédié dans le monde entier avec suivi.",
  "home.featured": "Chefs-d'œuvre à la une",
  "gallery.title": "Galerie de chefs-d'œuvre",
  "gallery.subtitle": "Chaque tableau est reproduit à la main, à l'huile sur toile - jamais imprimé.",
  "gallery.filterAll": "Tous les artistes",
  "gallery.empty": "Aucun tableau trouvé.",
  "artists.title": "Les maîtres",
  "artists.works": "Voir les œuvres",
  "artwork.by": "par",
  "artwork.order": "Commander ce tableau",
  "artwork.notFound": "Ce tableau est introuvable.",
  "order.size": "Taille de la toile",
  "order.frame": "Finition",
  "frame.rolled": "Toile roulée (en tube)",
  "frame.stretched": "Sur châssis, prête à accrocher",
  "frame.framed": "Châssis + cadre en bois",
  "order.subjects": "Personnes ou animaux sur la photo",
  "order.price.base": "Tableau",
  "order.price.frame": "Finition",
  "order.price.custom": "Portrait sur mesure",
  "order.price.shipping": "Livraison",
  "order.price.free": "Offerte",
  "order.price.total": "Total",
  "order.contact": "Adresse de livraison",
  "order.name": "Nom complet",
  "order.email": "E-mail",
  "order.phone": "Téléphone",
  "order.address": "Adresse",
  "order.city": "Ville",
  "order.postalCode": "Code postal",
  "order.country": "Pays",
  "order.notes": "Notes pour l'artiste (facultatif)",
  "order.submit": "Passer au paiement",
  "order.submitting": "Commande en cours…",
  "order.error": "Une erreur est survenue. Vérifiez le formulaire et réessayez.",
  "order.leadTime": "La peinture prend 2 à 3 semaines, plus 1 semaine de séchage avant l'expédition.",
  "custom.title": "Transformez votre photo en peinture à l'huile",
  "custom.subtitle": "Envoyez une photo nette et bien éclairée. Nos artistes la peindront à la main - vous validez l'esquisse avant que nous commencions.",
  "custom.upload": "Choisir une photo",
  "custom.uploadHint": "JPG, PNG ou WebP, jusqu'à 20 Mo. Plus la résolution est haute, meilleur est le tableau.",
  "custom.uploading": "Envoi…",
  "custom.uploaded": "Photo envoyée",
  "custom.replace": "Utiliser une autre photo",
  "custom.style": "Style de peinture",
  "custom.style.classic": "Réalisme classique",
  "custom.style.impressionist": "Impressionniste (comme Monet)",
  "custom.style.vangogh": "Touche expressive (comme Van Gogh)",
  "custom.style.modern": "Moderne, palette douce",
  "custom.needPhoto": "Veuillez d'abord envoyer une photo.",
  "track.title": "Suivre votre commande",
  "track.code": "Numéro de commande",
  "track.submit": "Rechercher",
  "track.notFound": "Aucune commande ne correspond à ce numéro et à cet e-mail.",
  "track.placed": "Passée le",
  "success.title": "Merci ! Votre commande est enregistrée.",
  "success.body": "Nous vous avons envoyé une confirmation par e-mail. Conservez votre numéro de commande pour suivre son avancement.",
  "status.awaiting_payment": "En attente de paiement",
  "status.paid": "Payée",
  "status.sketching": "Esquisse",
  "status.painting": "En peinture",
  "status.drying": "Séchage",
  "status.shipped": "Expédiée",
  "status.delivered": "Livrée",
  "status.cancelled": "Annulée",
  "common.loading": "Chargement…",
  "common.back": "Retour",
  "footer.tagline": "Peintures à l'huile faites main, livrées dans le monde entier.",
  "footer.follow": "Suivez-nous",
  "footer.docs": "Aide et documentation",
  "gallery.search": "Rechercher un tableau ou un artiste…",
  "sketch.title": "Votre esquisse est prête",
  "sketch.body": "Vérifiez la composition. Nous ne commençons à peindre qu'après votre validation.",
  "sketch.approve": "Valider l'esquisse",
  "sketch.change": "Demander des modifications",
  "sketch.feedback": "Que devons-nous modifier ?",
  "sketch.send": "Envoyer",
  "sketch.approved": "Esquisse validée - la peinture a commencé.",
  "sketch.changesSent": "Merci ! L'artiste vous enverra une esquisse révisée.",
  "checkout.title": "Paiement",
  "checkout.demoBanner": "Mode démo - le paiement en ligne n'est pas encore actif. Aucun montant ne sera débité et aucune donnée de carte n'est collectée.",
  "checkout.summary": "Récapitulatif",
  "checkout.method": "Moyen de paiement",
  "checkout.method.card": "Carte bancaire",
  "checkout.method.paypal": "PayPal",
  "checkout.method.wallet": "Apple Pay / Google Pay",
  "checkout.method.bank": "Virement bancaire",
  "checkout.cardNumber": "Numéro de carte",
  "checkout.expiry": "Expiration (MM/AA)",
  "checkout.cvc": "CVC",
  "checkout.cardName": "Nom sur la carte",
  "checkout.paypalNote": "Vous serez redirigé vers PayPal pour valider le paiement.",
  "checkout.walletNote": "Confirmez avec Face ID, Touch ID ou votre téléphone.",
  "checkout.bankNote": "Nous vous enverrons nos coordonnées bancaires par e-mail. Votre commande démarre à réception du virement (1 à 3 jours ouvrés).",
  "checkout.pay": "Payer {amount}",
  "checkout.processing": "Paiement en cours…",
  "checkout.secure": "Les paiements sont chiffrés et traités par notre partenaire de paiement. Nous ne stockons jamais les numéros de carte.",
  "checkout.demoDoneTitle": "Paiement simulé",
  "checkout.demoDoneBody": "Ceci était une démo - rien n'a été débité. Votre commande est enregistrée et reste « En attente de paiement » ; notre équipe vous contactera pour finaliser le paiement.",
  "checkout.failTitle": "Paiement refusé",
  "checkout.failBody": "Votre banque a refusé le paiement. Vérifiez les informations ou essayez un autre moyen.",
  "checkout.retry": "Réessayer",
  "checkout.viewOrder": "Voir ma commande",
  "track.payNow": "Payer maintenant",
  "browse.title": "Explorer",
  "browse.movements": "Mouvements artistiques",
  "browse.museums": "Musées",
  "browse.subjects": "Sujets",
  "browse.genres": "Genres",
  "artwork.year": "Année",
  "artwork.size": "Taille originale",
  "artwork.museum": "Musée",
  "artwork.movement": "Mouvement",
  "artwork.genre": "Genre",
  "artwork.subjects": "Sujets",
  "artwork.moreBy": "Autres œuvres de",
  "pager.prev": "Précédent",
  "pager.next": "Suivant",
  "count.paintings": "{n} tableaux",
  "fav.add": "Ajouter aux favoris",
  "fav.remove": "Retirer des favoris",
  "fav.title": "Mes favoris",
  "fav.empty": "Pas encore de favoris. Touchez le cœur sur un tableau que vous aimez, il vous attendra ici.",
  "fav.emptyCta": "Explorer la galerie",
  "fav.syncHint": "Connectez-vous avec Google pour retrouver vos favoris sur tous vos appareils.",
  "fav.saved": "Ajouté à vos favoris",
  "fav.nav": "Favoris",
  "account.signIn": "Se connecter",
  "account.signOut": "Se déconnecter",
  "account.signedInAs": "Connecté en tant que",
  "account.signInTitle": "Connexion à ArtLove365",
  "viewer.open": "Voir en plein écran",
  "viewer.close": "Fermer",
  "viewer.hint": "Molette ou pincement pour zoomer · glisser pour explorer · double-clic pour réinitialiser",
  "share.button": "Partager",
  "share.copied": "Lien copié",
  "artwork.story": "À propos de ce tableau",
  "artwork.details": "Détails",
  "artwork.aboutArtist": "À propos de l'artiste",
  "artwork.readArtist": "Découvrir la vie de {name}",
  "artwork.relatedArtists": "Œuvres d'artistes liés",
  "rel.influenced_by": "A inspiré {artist}",
  "rel.influenced": "Inspiré par {artist}",
  "rel.student_of": "Maître de {artist}",
  "rel.student": "Élève de {artist}",
  "rel.movement": "Aussi {movement}",
  "story.didYouKnow": "Le saviez-vous ?",
  "story.sources": "Sources",
  "story.aiNote": "Rédigé avec l'aide de l'IA à partir des sources ci-dessous. Une erreur ? Dites-le-nous.",
  "artist.relatedArtists": "Artistes liés",
  "artist.worksBy": "Œuvres de {name}",
  "nav.how": "Notre savoir-faire",
  "home.ctaArtists": "Découvrir les artistes",
  "home.discover": "Faisons connaissance",
  "home.howCardTitle": "Notre savoir-faire",
  "home.howCardBody": "De vrais peintres, de vraies toiles, de la peinture à l'huile et de la patience. Découvrez comment un chef-d'œuvre renaît à la main.",
  "home.customCardTitle": "Votre photo, peinte à l'huile",
  "home.customCardBody": "Famille, couple, animaux, la maison de votre enfance : découvrez comment une photo devient un tableau.",
  "home.featuredArtists": "Les grands maîtres",
  "home.browseMovements": "Explorer par mouvement",
  "common.readMore": "En savoir plus",
  "how.title": "Notre savoir-faire",
  "how.intro": "Chaque tableau ArtLove365 est peint à la main, à l'huile sur une vraie toile, par des peintres professionnels. Aucune impression, aucun raccourci. Voici ce qui se passe entre un chef-d'œuvre et votre mur.",
  "how.s1t": "Tout commence par un tableau qui vous touche",
  "how.s1b": "Parcourez des milliers de chefs-d'œuvre, lisez leurs histoires et gardez vos coups de cœur dans vos favoris.",
  "how.s2t": "Un peintre étudie l'original",
  "how.s2b": "Avant le premier coup de pinceau, le peintre étudie la composition, les couleurs et la façon dont le maître posait la peinture : l'ordre des couches compte autant que les couleurs.",
  "how.s3t": "Peint à la main, couche après couche",
  "how.s3b": "L'huile se construit lentement : une sous-couche, les grandes masses, puis les détails et les glacis. Une toile moyenne demande deux à trois semaines de travail.",
  "how.s4t": "Contrôlé, puis mis à sécher",
  "how.s4b": "Un peintre confirmé compare la toile à l'original. La peinture à l'huile a ensuite besoin d'environ une semaine pour sécher avant de voyager en sécurité.",
  "how.s5t": "Emballé avec soin, expédié dans le monde entier",
  "how.s5b": "Les tableaux voyagent roulés dans un tube rigide ou tendus dans une caisse renforcée, avec un suivi jusqu'à votre porte.",
  "how.materialsTitle": "Matériaux",
  "how.materialsBody": "Peintures à l'huile de qualité artiste, toile de coton ou de lin apprêtée, et vernis qui protège la surface pendant des décennies.",
  "how.customTitle": "Peindre d'après votre photo",
  "how.customBody": "Pour les portraits et les scènes personnelles, nous ajoutons une étape : vous validez une esquisse de la composition avant que nous commencions à peindre.",
  "custom.pageTitle": "Peintures à l'huile sur mesure d'après vos photos",
  "custom.pageIntro": "Une photo garde un instant. Un tableau le fait durer. Nos peintres transforment vos photos en portraits et en scènes peints à la main, dans le style de votre choix.",
  "custom.howTitle": "Comment ça marche",
  "custom.step1t": "Vous partagez une photo",
  "custom.step1b": "Une photo nette suffit ; nous pouvons aussi en réunir plusieurs dans une même scène.",
  "custom.step2t": "Vous validez une esquisse",
  "custom.step2b": "Notre peintre prépare la composition. Rien n'est peint tant que vous n'êtes pas satisfait.",
  "custom.step3t": "Nous la peignons à la main",
  "custom.step3b": "Huile sur toile, couche après couche, dans le style choisi.",
  "custom.step4t": "Elle arrive chez vous",
  "custom.step4b": "Après séchage et un dernier contrôle, votre tableau est emballé et expédié avec suivi.",
  "custom.stylesTitle": "Choisissez un style",
  "custom.styleDesc.classic": "Ressemblance fidèle, lumière douce et détails fins, dans la tradition des maîtres anciens.",
  "custom.styleDesc.impressionist": "La lumière et l'atmosphère en touches libres et vibrantes, comme un après-midi d'été chez Monet.",
  "custom.styleDesc.vangogh": "Touche épaisse et tourbillonnante, couleurs franches, inspirées de Van Gogh.",
  "custom.styleDesc.modern": "Formes épurées et palette douce et contemporaine pour les intérieurs modernes.",
  "custom.occasionsTitle": "Idéal pour",
  "custom.occ.family": "Portraits de famille",
  "custom.occ.couples": "Couples et mariages",
  "custom.occ.pets": "Animaux",
  "custom.occ.children": "Enfants",
  "custom.occ.memorial": "En souvenir",
  "custom.occ.home": "Maisons et lieux",
  "custom.tipsTitle": "Bien choisir sa photo",
  "custom.tip1": "Une image nette, surtout au niveau des yeux.",
  "custom.tip2": "Une lumière du jour douce ; évitez le flash et les filtres marqués.",
  "custom.tip3": "Des visages assez grands pour bien voir les expressions.",
  "custom.tip4": "Plusieurs photos ? Nous pouvons réunir personnes ou animaux dans un seul tableau.",
  "custom.explore": "Explorer les styles dans la galerie",
  "showcase.title": "Commandes que nous avons peintes",
  "showcase.subtitle": "De vrais tableaux peints pour nos clients, publiés avec leur accord.",
  "showcase.all": "Tous",
  "custom.occ.nail": "Décoration de salons de manucure",
  "custom.occ.other": "Autres",
  "home.newTitle": "Histoires nouvellement racontées",
  "home.newWhy": "Les derniers tableaux à recevoir leur histoire complète - du nouveau chaque jour.",
  "home.gemsTitle": "Trésors méconnus",
  "home.gemsWhy": "Moins célèbres, tout aussi émouvants. Des tableaux devant lesquels on passe trop vite.",
  "taxon.faqTitle": "Envie d'en savoir plus sur {name} ?",
  "notFound.title": "Page introuvable",
};
